<template>
  <div class="app-v-select-flat" :class="{
    'app-v-select-flat_danger': danger
  }">
    <label class="app-v-select-flat__label" :for="_uid" v-if="label">
      {{label}}
    </label>

    <v-select :options="options"
              :label="selectLabel"
              v-model="selectModel"
              :reduce="reduceFunction"
              class="app-v-select app-v-select-flat__select"
              :class="{
                'app-v-select_multiple': multiple,
                'app-v-select-flat__select_multiple': multiple
              }"
              :key="useDynamicKey ? `app-select-${selectModel}` : 'app-select'"
              v-bind="$attrs"
              :clearable="clearable"
              :searchable="searchable"
              :taggable="taggable"
              :noDrop="noDrop"
              :pushTags="pushTags"
              :close-on-select="closeOnSelect"
              :multiple="multiple"
              :appendToBody="appendToBody"
              @search:focus="updateTypeAheadPointer"
              @open="addScrollEvent"
              @close="deleteScrollEvent"
              ref="select"
              :filter="filterFunc"
              :filterBy="filterBy"
              :getOptionLabel="getOptionLabel"
    >
      <template slot="selected-option" slot-scope="option">
        <slot name="selected-option" v-bind="option">
          {{option[selectLabel]}}
        </slot>
      </template>
      <template slot="option" slot-scope="option">
        <slot name="option" v-bind="option">
          <div>
            {{option[selectLabel]}}
          </div>
        </slot>
      </template>
      <template slot="no-options">
        <slot name="no-options">
          Произошла ошибка
        </slot>
      </template>
    </v-select>
    <div class="app-v-select-flat__help" v-if="$slots.help">
      <slot name="help"/>
    </div>

    <transition name="fade">
      <div class="app-v-select-flat__validation-error" v-if="danger && dangerText.length">
        {{dangerText}}
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "AppVSelect",
    props: {
      label: {},
      value: {},
      options: {},
      selectLabel: {
        type: String,
        default: 'id'
      },
      reduceFunction: {
        type: Function,
        default(option){
          return option.id
        }
      },
      clearable: {
        default: false,
        type: Boolean
      },
      searchable: {
        default: false,
        type: Boolean
      },
      danger:{
        type: Boolean,
        default: false
      },
      dangerText: {
        type: String,
        default: ""
      },
      taggable: {
        type: Boolean,
        default: false
      },
      pushTags: {
        type: Boolean,
        default: false
      },
      closeOnSelect: {
        type: Boolean,
        default: true
      },
      noDrop: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      useDynamicKey: {
        type: Boolean,
        default: true
      },
      appendToBody: {
        type: Boolean,
        default: false
      },
      getOptionLabel: {
        type: Function,
        default(option) {
          if (typeof option === 'object') {
            if (!option.hasOwnProperty(this.label)) {
              return console.warn(
                  `[vue-select warn]: Label key "option.${this.label}" does not` +
                  ` exist in options object ${JSON.stringify(option)}.\n` +
                  'https://vue-select.org/api/props.html#getoptionlabel'
              )
            }
            return option[this.label]
          }
          return option;
        }
      },
      filterBy: {
        type: Function,
        default(option, label, search) {
          return (label || "").toLowerCase().indexOf(search.toLowerCase()) > -1;
        }
      },
      filterFunc: {
        type: Function,
        default(options, search) {
          return options.filter(option => {
            let label = this.getOptionLabel(option);
            if (typeof label === "number") {
              label = label.toString();
            }
            return this.filterBy(option, label, search);
          });
        }
      },
    },
    computed: {
      selectModel: {
        get(){
          return this.value
        },
        set(v){
          this.$emit('input', v);
          this.$emit('update:danger', false);
        }
      }
    },
    methods: {
      updateTypeAheadPointer(){
        let selectedIndex = -1;
        let select = this.$refs.select;
        for (let i = 0; i < select.filteredOptions.length; i++) {
          if (select.isOptionSelected(select.filteredOptions[i])) {
            selectedIndex = i;
            break;
          }
        }
        select.typeAheadPointer = selectedIndex;
      },
      wheelListener(event){
        event.stopPropagation();
      },
      addScrollEvent(){
        this.$nextTick(() => {
          let menu = this.$refs.select.$refs.dropdownMenu;
          if(menu){
            menu.addEventListener('wheel', this.wheelListener);
          }
        });
      },
      deleteScrollEvent(){
        let menu = this.$refs.select.$refs.dropdownMenu;
        if(menu){
          menu.removeEventListener('wheel', this.wheelListener);
        }
      },
      focus(){
        this.$refs.select.$el.querySelector('.vs__search').focus();
      },
    }
  }
</script>

<style lang="scss">
  .vs__dropdown-menu{
    z-index: 100001!important;
  }

  .app-v-select-flat{
    position: relative;

    .vs__spinner{
      border-top: 3px solid rgba(var(--app-primary), 1);
      border-right: 3px solid rgba(var(--app-primary), 1);
      border-bottom: 3px solid rgba(var(--app-primary), 1);
      border-left: 3px solid rgba(60, 60, 60, .35);
      width: 3em;
      height: 3em;
    }

    &__help{
      text-align: center;
      font-size: 12px;
      margin-top: 5px;
    }

    &__label{
      color: rgba(var(--app-heading-color-light), 1);
      font-size: 14px;
      margin-bottom: 2px;
      display: block;
    }

    &__select {

      &.vs--single.vs--open {
        .vs__selected {
          position: relative;
        }

        .vs__selected {
          cursor: text;
        }

      }

      .vs__dropdown-toggle {
        border-radius: 2px!important;
        padding: 0 5px 0 0!important;
        border: 1px solid #ced4da!important;
        min-height: 36px!important;

        .vs__search {
          padding: 5px 10px!important;
          color: rgba(var(--app-content-color), 1);
          margin: 0;
          font: 400 1rem system-ui;
          letter-spacing: 0;
          height: 100%;
          border: none;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 100%;
          cursor: pointer;

          &::placeholder{
            color: #ced4da;
          }
        }
      }

      .vs__selected {
        margin: 0;
        padding: 5px 10px!important;
        font: 400 1rem system-ui;
        letter-spacing: 0;
        border: none;
        color: rgba(var(--app-content-color), 1);
        flex: 1;


        &-options {
          padding: 0;
        }
      }

      .vs__actions {
        padding: 0;
        margin: 0;
      }

      .vs__clear {
        width: 14px;
        height: 14px;
        margin: 0;
        color: rgba(var(--app-content-color), 1);


        .feather-icon {
          width: 100%;
          height: 100%;

          svg {
            width: 100%;
            height: 100%;
          }
        }
      }

      .vs__open-indicator {
        width: 14px;
        height: 14px;
        color: rgba(var(--app-content-color), 1);
        cursor: pointer;


        svg {
          width: 100%;
          height: 100%;
        }
      }

      .vs__no-options {
        text-align: center;
        font-size: 12px;
        padding: 5px 0;
      }

      &.vs--disabled {
        opacity: 0.5;
        .vs__actions {
          display: none;
        }

        .vs__dropdown-toggle,
        .vs__clear,
        .vs__search,
        .vs__selected,
        .vs__open-indicator {
          background: transparent;
          cursor: default;
        }

        .vs__selected {
          //opacity: .4;
        }
      }

      &_multiple {
        .vs__selected {
          display: inline-flex;
          flex: 0;
          margin: 2.5px!important;
          padding: 5px!important;
        }

        .vs__deselect {
          width: 14px;
          height: 14px;

          .feather-icon {
            width: 14px;
            height: 14px;

            svg {
              width: 100%;
              height: 100%;
            }
          }
        }

        .vs__open-indicator {
          margin-top: -5px;
        }

        .vs__dropdown-toggle {
          //margin-bottom: -5px;
          padding-top: 2.5px!important;
          padding-bottom: 2.5px!important;
          padding-left: 5px!important;
        }

        .vs__selected-options {
          //padding-bottom: 5px;
          //margin-top: -5px;
        }

        .vs__dropdown-toggle {
          .vs__search {
            padding-left: 5px!important;
            position: relative;
            height: auto;
            flex: 1;
          }
        }

      }
    }

    &_danger{
      .vs__dropdown-toggle {
        border-color: rgba(var(--app-danger), 1)!important;
      }
    }

    &__validation-error{
      display: inline-block;
      color: rgba(var(--app-danger), 1);
      overflow: hidden;
      transition: all .25s ease;
      border: 1px solid #eee;
      background: #fff;
      box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
      margin-top: 3px;
      font-weight: 600;
      text-transform: uppercase;
      padding: 4px;
      line-height: 1.2;
      font-size: 10px;
      border-radius: 2px;
      z-index: 100;
      position: absolute;
      top: 100%;
      left: 0;
    }
  }

  .vs__dropdown-menu {
    padding: 2px 0!important;
    border: 1px solid #ced4da!important;
    margin-top: -1px!important;
  }

  .vs__dropdown-option {
    font: 400 1rem system-ui!important;
    letter-spacing: 0!important;
    padding: 7px 14px 7px 12px!important;
    border-left: 2px solid transparent!important;
    color: rgba(var(--app-content-color), 1)!important;

    &--highlight {
      background: #f5f8fa!important;
      color: rgba(var(--app-content-color), 1)!important;
    }

    &--selected {
      border-left-color: rgba(var(--app-primary), 1)!important;
      background: #f5f8fa!important;
      color: rgba(var(--app-content-color), 1)!important;
    }
  }


</style>
